import React from 'react';
import MessageStatsDashboard from './components/MessageStatsDashboard';
import './index.css';

function App() {
  return (
    <div className="App">
      <MessageStatsDashboard />
    </div>
  );
}

export default App;